import React, { useEffect, useState } from "react";
import SafeImage from "../../../layout/reusable/SafeImage";
import { getTeams } from "../../../utils/cms.utils";

const TeamMain = () => {
    const [teamData, setTeamData] = useState([]);

    useEffect(() => {
        const data = getTeams();

        const items = Array.isArray(data) ? data : [];

        // sort by orderNo asc
        const sorted = [...items].sort(
            (a, b) => (a.orderNo ?? 0) - (b.orderNo ?? 0)
        );

        setTeamData(sorted);
    }, []);

    return (
        <div className="team__area section-padding-three">
            <div className="container">

                {/* ===== INTRO ===== */}
                <div className="row mb-60 team__intro">
                    <div className="col-lg-8 text-center team__intro-inner">
                        <p className="subtitle team__subtitle">
                            Our Leadership
                        </p>

                        <h2 className="title_split_anim">
                            Company Organizational Structure
                        </h2>
                    </div>
                </div>

                {/* ===== TEAM GRID ===== */}
                <div className="row">
                    {teamData.map((item) => (
                        <div
                            className="col-lg-3 col-md-6 mb-40"
                            key={item.id}
                        >
                            <div className="team__card">

                                {/* IMAGE */}
                                <div className="team__card-image">
                                    <SafeImage
                                        src={item.image}
                                        alt={item.name}
                                    />
                                </div>

                                {/* CONTENT */}
                                <div className="team__card-content">
                                    <h5 className="team__name">
                                        {item.name}
                                    </h5>

                                    <span className="team__position">
                                        {item.positionEn}
                                    </span>

                                    {item.positionId && (
                                        <span className="team__position-sub">
                                            {item.positionId}
                                        </span>
                                    )}

                                    {/* EMAIL */}
                                    {item.email ? (
                                        <a
                                            href={`mailto:${item.email}`}
                                            className="team__email"
                                        >
                                            <i className="fas fa-envelope" />
                                            {item.email}
                                        </a>
                                    ) : (
                                        <span className="team__email team__email--hidden">
                                            <i className="fas fa-lock" />
                                            Hidden Information
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}

                    {/* ===== FOOTNOTE ===== */}
                    <div className="col-xl-12 team__footer-text">
                        <p className="team__desc">
                            Our leadership team is composed of experienced professionals
                            who combine strong technical expertise with strategic insight.
                            Through integrity, accountability, and collaboration, we ensure
                            every project is delivered with excellence and reliability.
                        </p>

                        <p className="team__desc-sub">
                            Tim kepemimpinan kami terdiri dari para profesional
                            berpengalaman dengan keahlian teknis dan wawasan strategis
                            untuk memastikan setiap proyek berjalan optimal.
                        </p>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default TeamMain;
